import { render } from "./CalendarDetailPage.vue?vue&type=template&id=6b18ae4b&scoped=true&ts=true"
import script from "./CalendarDetailPage.vue?vue&type=script&lang=ts"
export * from "./CalendarDetailPage.vue?vue&type=script&lang=ts"

import "./CalendarDetailPage.vue?vue&type=style&index=0&id=6b18ae4b&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b18ae4b"]])

export default __exports__